<template>
  <div class="bg-white rounded-xl shadow p-6">
    <!-- Header -->
    <div class="flex justify-between items-center mb-6">
      <h2 class="text-xl font-semibold text-gray-800">Ad Campaigns</h2>
      <button
        @click="exportToCSV"
        class="bg-blue-600 hover:bg-blue-700 text-white text-sm px-4 py-2 rounded-lg shadow transition"
      >
        Export to CSV
      </button>
    </div>

    <!-- Table -->
    <div class="overflow-x-auto">
      <table class="min-w-full border border-gray-200">
        <thead class="bg-gray-50">
          <tr>
            <th class="px-4 py-2 text-left text-sm font-semibold text-gray-600 border-b">Campaign ID</th>
            <th class="px-4 py-2 text-left text-sm font-semibold text-gray-600 border-b">Campaign Name</th>
            <th class="px-4 py-2 text-left text-sm font-semibold text-gray-600 border-b">Client</th>
            <th class="px-4 py-2 text-left text-sm font-semibold text-gray-600 border-b">Status</th>
            <th class="px-4 py-2 text-right text-sm font-semibold text-gray-600 border-b">Revenue (Ksh)</th>
            <th class="px-4 py-2 text-left text-sm font-semibold text-gray-600 border-b">Start Date</th>
            <th class="px-4 py-2 text-left text-sm font-semibold text-gray-600 border-b">End Date</th>
            <th class="px-4 py-2 text-center text-sm font-semibold text-gray-600 border-b">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="campaign in campaigns"
            :key="campaign.campaignid"
            class="hover:bg-gray-50 transition"
          >
            <td class="px-4 py-2 border-b">{{ campaign.campaignid }}</td>
            <td class="px-4 py-2 border-b">{{ campaign.campaignname }}</td>
            <td class="px-4 py-2 border-b">{{ campaign.clientname }}</td>
            <td class="px-4 py-2 border-b">
              <span
                :class="{
                  'text-green-600 font-medium': campaign.status === 'Active',
                  'text-red-600 font-medium': campaign.status === 'Paused',
                  'text-gray-600 font-medium': campaign.status === 'Inactive'
                }"
              >
                {{ campaign.status }}
              </span>
            </td>
            <td class="px-4 py-2 border-b text-right">
              {{ Number(campaign.revenue).toLocaleString() }}
            </td>
            <td class="px-4 py-2 border-b">{{ formatDate(campaign.activate_time) }}</td>
            <td class="px-4 py-2 border-b">{{ formatDate(campaign.expire_time) }}</td>

            <td class="px-4 py-2 text-center border-b space-x-2">
              <!-- View Banners -->
              <button
                @click="viewBanners(campaign)"
                class="text-blue-600 hover:text-blue-800 text-sm font-medium"
              >
                View Banners
              </button>

              <!-- Edit -->
              <button
                @click="editCampaign(campaign)"
                class="text-yellow-600 hover:text-yellow-800 text-sm font-medium"
              >
                Edit
              </button>

              <!-- Pause / Activate -->
              <button
                @click="toggleCampaignStatus(campaign)"
                :class="campaign.status === 'Active' 
                  ? 'text-red-600 hover:text-red-800' 
                  : 'text-green-600 hover:text-green-800'"
                class="text-sm font-medium"
              >
                {{ campaign.status === 'Active' ? 'Pause' : 'Activate' }}
              </button>
            </td>
          </tr>

          <tr v-if="!campaigns.length">
            <td colspan="8" class="px-4 py-4 text-center text-gray-500">
              No campaigns found
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "AdCampaignList",
  data() {
    return {
      campaigns: [],
    };
  },
  mounted() {
   // this.fetchCampaigns();
  },
  methods: {
    async fetchCampaigns() {
      try {
        const LOGIN_API_URL = "https://ads.brandfi.co.ke/ads/adsuiapi/login.php";
        const loginParams = {
          username: "b.arudo@saritcentre.com",
          password: "b.arudo@saritcentre.com",
          client_id: "BrandFiApiUI",
          client_secret: "BrandFiApiUI",
          grant_type: "password",
        };

        // Step 1: Authenticate
        const loginRes = await axios.post(LOGIN_API_URL, loginParams, {
          headers: { "Content-Type": "application/json" },
        });

        const { access_token } = loginRes.data;

        // Step 2: Fetch campaign list
        const API_URL =
          "https://ads.brandfi.co.ke/ads/adsuiapi/agency/advertiser-campaigns.php?access_token=" +
          access_token;
 
        const response = await axios.post(API_URL, { agencyid: "15", page: 1 });

        // Step 3: Parse and normalize campaigns
        const data = response.data.data || [];
        this.campaigns = data.map((item) => ({
          campaignid: item.campaignid,
          campaignname: item.campaignname,
          clientname: item.clientname,
          revenue: item.revenue,
          activate_time: item.activate_time,
          expire_time: item.expire_time,
          status: this.resolveStatus(item.status, item.pause),
        }));

        console.log("✅ Loaded campaigns:", this.campaigns);
      } catch (err) {
        console.error("❌ Failed to fetch campaigns:", err);
      }
    },

    resolveStatus(status, pause) {
      if (pause === "1") return "Paused";
      if (status === "0") return "Active";
      return "Inactive";
    },

    exportToCSV() {
      if (!this.campaigns.length) return alert("No data to export.");

      const headers = [
        "Campaign ID,Campaign Name,Client,Status,Revenue (Ksh),Start Date,End Date",
      ];
      const rows = this.campaigns.map((c) =>
        [
          c.campaignid,
          c.campaignname,
          c.clientname,
          c.status,
          c.revenue,
          this.formatDate(c.activate_time),
          this.formatDate(c.expire_time),
        ].join(",")
      );

      const csvContent = headers.concat(rows).join("\n");
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });

      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.setAttribute("download", "campaigns.csv");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },

    viewBanners(campaign) {
      this.$router.push({
        name: "banner_list",
        params: { campaignId: campaign.campaignid },
      });
    },

    editCampaign(campaign) {
      this.$router.push({
        name: "edit_campaign",
        query: { id: campaign.campaignid },
      });
    },

    async toggleCampaignStatus(campaign) {
      try {
        // TODO: Replace with actual API endpoint
        const action =
          campaign.status === "Active" ? "pause" : "activate";

        console.log(`🔄 ${action} campaign`, campaign.campaignid);

        // Simulate local update
        campaign.status =
          campaign.status === "Active" ? "Paused" : "Active";
      } catch (err) {
        console.error("❌ Failed to toggle campaign status:", err);
      }
    },

    formatDate(date) {
      if (!date) return "—";
      return new Date(date).toLocaleDateString();
    },
  },
};
</script>

<style scoped>
table th,
table td {
  white-space: nowrap;
}
</style>
